import { SxProps } from "@mui/material";

export const sxTextField: SxProps = {
  width: '100%',
  input: {
    fontFamily: 'Montserrat-Regular',
    color: 'var(--secondary-dark-grey)',
    fontSize: '16px',
  },
  '@media (max-width: 1130px)': {
    width: '100%'
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'white',
    borderRadius: '12px',
    border: '1px solid var(--border-secondary)',
    height: '48px',
    '& fieldset': {
      border: 'inherit',
      boxShadow: 'inherit'
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: '1px solid var(--border-secondary)',
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: 'var(--border-secondary)',
    },
    "&.Mui-error .MuiOutlinedInput-notchedOutline": {
      border: '1px solid #CC3D3D',
    },
    "&.Mui-disabled": {
      backgroundColor: 'var(--secondary-grey)',
      color: 'white',
    },
  },
}

export const sxLargeTextTextField: SxProps = {
  width: '100%',
  input: {
    fontFamily: 'Montserrat-Regular',
    color: 'var(--secondary-dark-grey)',
    fontSize: '16px',
  },
  '@media (max-width: 1130px)': {
    width: '100%'
  },
  '& .MuiOutlinedInput-root': {
    alignItems: 'flex-start',
    height: 'unset',
    minHeight: '140px',
    fontFamily: 'Montserrat-Regular',
    backgroundColor: 'white',
    borderRadius: '12px',
    border: '1px solid var(--border-secondary)',
    '& fieldset': {
      border: 'inherit',
      boxShadow: 'inherit'
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: '1px solid var(--border-secondary)',
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: 'var(--border-secondary)',
    },
    "&.Mui-error .MuiOutlinedInput-notchedOutline": {
      border: '1px solid #CC3D3D',
    },
    "&.Mui-disabled": {
      backgroundColor: 'var(--secondary-grey)',
      color: 'white',
    },
  },
}